import React from "react";
import ToolkitProvider, {Search} from "react-bootstrap-table2-toolkit";
import {Container} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";


export const AdminUserLogGrid = ({users}) => {

    const {SearchBar} = Search;

    const columns = [
        {
            dataField: 'userRemoved',
            text: 'Användare borttagen: ',
            sort: true,
            headerStyle: {textDecoration: 'underline', cursor: 'pointer'}
        },
        {
            dataField: 'removedBy',
            text: 'Borttagen utav: ',
            sort: true,
            headerStyle: {textDecoration: 'underline', cursor: 'pointer'}
        },
        {
            dataField: 'timeStamp',
            text: 'Tidpunkt: ',
            sort: true,
            headerStyle: {textDecoration: 'underline', cursor: 'pointer'}
        }

    ];

    return (
        <Container fluid className={"leadsGrid"}>
            <Container>
                <h1>
                    Borttagna användare
                </h1>

            </Container>


            <ToolkitProvider
                keyField="id"
                data={users}
                columns={columns}
                search
                condensed={true}
            >
                {props => (
                    <div>
                        <SearchBar placeholder="Sök" srText={null}
                                   className="SearchBar" {...props.searchProps} />
                        <BootstrapTable wrapperClasses="table-responsive" {...props.baseProps} />
                    </div>
                )}
            </ToolkitProvider>
        </Container>
    )

}
